import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "disabled"]

import { computed } from "vue";

type ButtonProps = {
  disabled?: boolean;
  fullWidth?: boolean;
  loading?: boolean;
  outline?: boolean;
  label: string;
  color?: string;
  id?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    disabled: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    label: {},
    color: { default: "primary" },
    id: {}
  },
  emits: ["onClick"],
  setup(__props: any, { emit: __emit }) {

// TODO: Aplicar SOLID



const emits = __emit;

const btnColor = computed(() =>
  __props.outline ? `btn-outline-${__props.color}` : `btn-${__props.color}`
);

const clicked = () => {
  if (__props.disabled) return;
  emits("onClick");
};

return (_ctx: any,_cache: any) => {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Typograph = _resolveComponent("Typograph")!

  return (_openBlock(), _createElementBlock("button", {
    id: _ctx.id,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clicked()), ["prevent"])),
    disabled: _ctx.loading || _ctx.disabled,
    class: _normalizeClass(["btn d-flex align-items-center justify-content-center", [{ 'w-100': _ctx.fullWidth }, btnColor.value]])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          size: "sm",
          class: "me-2"
        }))
      : _createCommentVNode("", true),
    (_ctx.$slots.leftContent)
      ? _renderSlot(_ctx.$slots, "leftContent", { key: 1 })
      : _createCommentVNode("", true),
    _createVNode(_component_Typograph, {
      variant: "action",
      class: "mt-1"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }),
    (_ctx.$slots.rightContent)
      ? _renderSlot(_ctx.$slots, "rightContent", { key: 2 })
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})